module.exports = __webpack_public_path__ + "assets/img/conversion_coin.ec25181f.png";